import Commons from '../../../../Services/Common/Common';

/**
 * COM_BASIC 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 * - mapper: 조회/저장/삭제 API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context) / mapRowsBySchema(rows, mapper, context) 사용
 */
export const COM_BASIC_Schema = {
  fields: {
    no: { initial: '', label: 'No' },
    coCd: { initial: '', label: '회사코드' },
    coNm: { initial: '', label: '회사명', required: 'Y', requiredWhen: 'ADMIN' },
    coId: { initial: '', label: '대표자 ID' },
    name: { initial: '', label: '대표자(사업주)' },
    address1: { initial: '', label: '주소' },
    address2: { initial: '', label: '상세주소' },
    contractStartDate: { initial: '', label: '계약시작일자' },
    contractEndDate: { initial: '', label: '계약종료일자' },
    contractMemberCount: { initial: 0, label: '총계약인원 수' },
    monthlyContractFee: {
      initial: '',
      label: '계약금(월)',
      required: 'Y',
      requiredWhen: 'ADMIN',
    },
    paymentDay: {
      initial: '',
      label: '결제일(매월)',
      required: 'Y',
      requiredWhen: 'ADMIN',
    },
  },

  mapper: {
    search1: {
      Userid: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || ''),
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo?.coCd || ''),
    },
    search2: {},

    save1: {
      CoCd: (row) => Commons.EncryptAES(row.coCd || ''),
      CoNm: (row) => Commons.EncryptAES(row.coNm || ''),
      CoId: (row) => Commons.EncryptAES(row.coId || ''),
      Address1: (row) => Commons.EncryptAES(row.address1 || ''),
      Address2: (row) => Commons.EncryptAES(row.address2 || ''),
      ContractStartDate: (row) => Commons.EncryptAES(row.contractStartDate || ''),
      ContractEndDate: (row) => Commons.EncryptAES(row.contractEndDate || ''),
      ContractMemberCount: (row) =>
        Commons.EncryptAES(String(row.contractMemberCount ?? '0')),
      MonthlyContractFee: (row) =>
        Commons.EncryptAES(String(row.monthlyContractFee ?? '')),
      PaymentDay: (row) => {
        const raw = row.paymentDay;
        if (raw === '' || raw === null || raw === undefined) {
          return Commons.EncryptAES('');
        }
        const n = Math.min(31, Math.max(1, Number(raw)));
        return Commons.EncryptAES(Number.isFinite(n) ? String(n) : '');
      },
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      CoCd: (row) => Commons.EncryptAES(row.coCd || ''),
      UserId: (row) => Commons.EncryptAES(row.userId || ''),
      RegId: (row) => Commons.EncryptAES(row.regId || ''),
    },
  },
};
